// extracted by mini-css-extract-plugin
export default {"homePageView":"HomePageView_homePageView__C6Eot","content":"HomePageView_content__Rubii","homeButton":"HomePageView_homeButton__WjCoj"};